var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.hasAlerts)?_c('div',{staticClass:"right-side-alert-current-lot"},[(_vm.isUnavailable)?_c('p',[_vm._v("\n        Acest lot a fost retras din licitație\n    ")]):_vm._e()]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-15e9061a","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/right-side-alert-current-lot/right-side-alert-current-lot.vue
// module id = null
// module chunks = 